// src/components/RelatedPackages.js
import React, { useState, useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../FireBase';
import FetRoomCard from './FetRoomCard'; // Reuse room card UI
import '../css/RelatedRooms.css'; // Reuse same styles
import FetPackageCard from './FetPackages';

const RelatedPackages = ({ currentPackageId }) => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const carouselRef = useRef(null);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'packages'));
        const data = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(pkg => pkg.id !== currentPackageId);
        setPackages(data);
        console.log(data)
      } catch (error) {
        console.error('Error fetching packages:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPackages();
  }, [currentPackageId]);

  const scroll = direction => {
    if (carouselRef.current) {
      const scrollAmount = carouselRef.current.clientWidth;
      carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  if (loading) {
    return (
      <div className="related-rooms py-5 text-center">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (packages.length === 0) return null;

  return (
    <section className="related-rooms pb-5 position-relative">
      <div className="container-fluid">
        <h2 className="section-title">You may also like</h2>

        <div ref={carouselRef} className="carousel-container">
          {packages.map(pkg => (
            <FetPackageCard key={pkg.id} pkg={pkg} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedPackages;